import * as React from 'react';

export interface IStatBlock {
  value: string;
  mode?: 'plus' | 'percent' | 'rating' | 'none';
  subtitle: string;
}

const suffixMap: Record<NonNullable<IStatBlock['mode']>, string> = {
  plus: '+',
  percent: '%',
  rating: '★',
  none: '',
};

export const StatBlock = ({value, mode = 'none', subtitle}: IStatBlock) => {
  return (
    <div className="flex flex-col items-center gap-1 text-center">
      <p className="text-subtitlesmall md:text-subtitlelarge font-title">
        {value}
        <span className="text-hotcalypso">{suffixMap[mode]}</span>
      </p>
      <p className="text-smallbodymob md:text-smallbody">{subtitle}</p>
    </div>
  );
};
